<div class="d-none d-md-block table-container">
  <app-list-view-toolbar
    [columns]="columns"
    [isSticky]="isToolbarSticky"
    [columnDefinition]="columnDefinition"
    [preferencesKey]="preferencesKey"
    (columnsChanged)="ColumnChanged($event)"
  >
    <div toolbar-scroll class="toolbar-horizontal-scroll" #toolbarScrollView (scroll)="onToolbarScroll()">
      <div class="toolbar-horizontal-scroll-content" #toolbarScrollContent></div>
    </div>
    <app-paging
      toolbar-actions
      [resetOnTotalCountChange]="false"
      [totalCount]="totalCount"
      [pageNumber]="page"
      [itemsPerPage]="pageSize"
      [compact]="true"
      (onPageChange)="pagingChanged($event)"
    ></app-paging>
  </app-list-view-toolbar>
  <div class="scroll-x scroll-x-shadows" #scrollView (scroll)="onTableScroll()">
    <table class="table table-hover" #tableView>
      <thead>
        <tr>
          @if (multiselect) {
            <th class="multiselect-menu-container no-padding-left">
              <div class="multiselect-header no-padding-left">
                <div class="select-box">
                  <astral-checkbox
                    class="list-selection-checkbox"
                    [checked]="!!selectAllControl.value"
                    [showCaption]="false"
                    variant="compact"
                    shape="square"
                    (checkedChange)="selectAllControl.setValue($event)"
                  ></astral-checkbox>
                </div>
                <div class="d-flex">
                  <div class="open-menu-btn" (mouseenter)="onMenuMouseEnter()" (mouseleave)="onMenuMouseLeave()">
                    <div class="flex-center">
                      <span class="circle-4 mr-1"></span><span class="circle-4 mr-1"></span><span class="circle-4"></span>
                    </div>
                    @if (showMenu) {
                      <div class="menu-container action-menu">
                        <div>
                          <span class="action-menu-pointer"></span>
                        </div>
                        <ul class="menu">
                          @for (definition of menuDefinition; track definition) {
                            <li>
                              <button class="menu-item" type="button" (click)="execute(definition.commandId)">
                                {{ definition.header | translate }}<i class="{{ definition.icon }}"></i>
                              </button>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </th>
          }

          @if (!multiselect) {
            <th class="counter">{{ 'COMMON.COUNT' | translate }}</th>
          }

          @for (column of selectedColumns; track column) {
            @if (column.helpText) {
              <th
                class="column-header"
                appTooltip="{{ column.helpText | translate }}"
                tooltipPosition="below"
                [dh-list-view-header]="column.id"
                [canSort]="allowSort(column)"
                (stateChange)="onStateChange($event)"
                >
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
            @if (!column.helpText) {
              <th
                class="column-header"
                [dh-list-view-header]="column.id"
                [canSort]="allowSort(column)"
                (stateChange)="onStateChange($event)"
                >
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
          }
          <th class="column-header"></th>
        </tr>
      </thead>
      <tbody class="table-striped">
        @for (row of rows; track trackRow($index, row); let i = $index) {
          <tr appListViewItem [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
            <td>
              @if (multiselect) {
                <div class="rowcount">
                  <astral-checkbox
                    class="list-selection-checkbox"
                    [checked]="row.selected"
                    [label]="getRowNumber(i).toString()"
                    variant="compact"
                    shape="square"
                    (checkedChange)="selectionChanged($event, row)"
                  ></astral-checkbox>
                </div>
              }
              @if (!multiselect) {
                <span>{{ getRowNumber(i) }}</span>
              }
            </td>
            @for (column of selectedColumns; track column) {
              <td (click)="onRowClicked(row, $event)">
                <dh-custom-view
                  [isPhoneNumber]="column.isPhoneNumber"
                  [viewType]="column.viewType"
                  [value]="row.getValue(column)"
                  [helpText]="row.getHelpText(column)"
                ></dh-custom-view>
              </td>
            }
            <td></td>
            @if (hasContextMenu) {
              <app-context-menu
                [context]="row.dataSource"
                [smaller]="true"
                [menuDefinition]="contextMenuDefinition"
              ></app-context-menu>
            }
          </tr>
        }
        <tr class="list-summary">
          <td>{{ selectedItemsCount ? selectedItemsCount.toString() + '/' : '' }}{{ totalCount }}</td>
          @for (column of selectedColumns; track column) {
            <td>
              @if (column.sum) {
                @for (summary of sumValues(column); track $index) {
                  <div>{{ summary.displayValue }}</div>
                }
              }
            </td>
          }
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-paging [resetOnTotalCountChange]="false" [totalCount]="totalCount" [pageNumber]="page" [itemsPerPage]="pageSize" (onPageChange)="pagingChanged($event)"></app-paging>
</div>

<div class="d-block d-md-none">
  @if (rows.length > 0) {
    <app-list-view-toolbar
      [columns]="columns"
      [columnDefinition]="columnDefinition"
      [preferencesKey]="preferencesKey"
      [isSticky]="isToolbarSticky"
      (columnsChanged)="ColumnChanged($event)"
    ></app-list-view-toolbar>
  }
  <app-paging
    class="mobile-pagination"
    [resetOnTotalCountChange]="false"
    [totalCount]="totalCount"
    [pageNumber]="page"
    [itemsPerPage]="pageSize"
    (onPageChange)="pagingChanged($event)"
  ></app-paging>
  @if (isEmpty) {
    <p class="help-text">{{ 'COMMON.EMPTY_LIST' | translate }}</p>
  }
  @for (row of rows; track trackRow($index, row)) {
    <div class="entry-m" [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
      @if (contextMenuDefinition) {
        <div class="float-right">
          <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [alwaysVisible]="true"></app-context-menu>
        </div>
      }
      <astral-checkbox
        class="list-selection-checkbox list-selection-checkbox--mobile"
        [checked]="row.selected"
        [showCaption]="false"
        variant="compact"
        shape="square"
        (checkedChange)="selectionChanged($event, row)"
      ></astral-checkbox>
      <ul class="mobile-list-view" (click)="onRowClicked(row, $event)">
        @for (column of selectedColumns; track column) {
          @if (row.getValue(column)) {
            <li>
              <div class="property-name-m">{{ column.caption | translate }}</div>
              <dh-custom-view
                [isPhoneNumber]="column.isPhoneNumber"
                [viewType]="column.viewType"
                [value]="row.getValue(column)"
                [helpText]="row.getHelpText(column)"
              ></dh-custom-view>
            </li>
          }
        }
      </ul>
    </div>
  }
  <app-paging
    class="mobile-pagination"
    [class.mobile-pagination--with-selection]="multiselect"
    [resetOnTotalCountChange]="false"
    [totalCount]="totalCount"
    [pageNumber]="page"
    [itemsPerPage]="pageSize"
    (onPageChange)="pagingChanged($event)"
  ></app-paging>
  @if (multiselect) {
    <div class="multiselect-header-m">
      <div class="d-flex align-items-center w-100">
        <astral-checkbox
          class="list-selection-checkbox"
          [checked]="!!selectAllControl.value"
          [showCaption]="false"
          variant="compact"
          shape="square"
          (checkedChange)="selectAllControl.setValue($event)"
        ></astral-checkbox>
        @if (selectedItemsCount == 0) {
          <span>{{ 'NO_ITEMS_SELECTED_TEXT' | translate }}</span>
        }
        @if (selectedItemsCount == 1) {
          <span>{{ 'SINGLE_ITEM_SELECTED_TEXT' | translate }}</span>
        }
        @if (selectedItemsCount > 1) {
          <span>{{ 'PLURAL_ITEMS_SELECTED_TEXT' | translate: { count: selectedItemsCount } }}</span>
        }
      </div>
      <button class="open-menu-btn" [class.actions-active]="selectedItemsCount" type="button" (click)="openMenu()">
        <span class="circle-4 mr-1"></span><span class="circle-4 mr-1"></span><span class="circle-4"></span>
      </button>
      <div class="position-relative">
        @if (showMenu) {
          <div class="menu-container action-menu">
            <ul class="menu">
              @for (definition of menuDefinition; track definition) {
                <li>
                  <button class="menu-item" type="button" (click)="execute(definition.commandId)">
                    {{ definition.header | translate }}<i class="{{ definition.icon }}"></i>
                  </button>
                </li>
              }
            </ul>
            <div class="action-menu-pointer-container">
              <span class="action-menu-pointer"></span>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
